/* Create action types */
import createActionTypes from '../createActionTypes';

export const FETCH_SURVEY = createActionTypes('FETCH_SURVEY');
export const SUBMIT_SURVEY = createActionTypes('SUBMIT_SURVEY');
